<script setup>

</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clip-path="url(#clip0_905961_2829)">
      <path d="M10.0026 19.1693C15.0651 19.1693 19.1693 15.0651 19.1693 10.0026C19.1693 4.9401 15.0651 0.835938 10.0026 0.835938M10.0026 19.1693C4.9401 19.1693 0.835938 15.0651 0.835938 10.0026C0.835938 4.9401 4.9401 0.835938 10.0026 0.835938M10.0026 19.1693C12.5026 19.1693 13.3359 15.0026 13.3359 10.0026C13.3359 5.0026 12.5026 0.835938 10.0026 0.835938M10.0026 19.1693C7.5026 19.1693 6.66927 15.0026 6.66927 10.0026C6.66927 5.0026 7.5026 0.835938 10.0026 0.835938M1.66927 13.3359H18.3359M1.66927 6.66927H18.3359" stroke="white" stroke-width="1.5"/>
    </g>
    <defs>
      <clipPath id="clip0_905961_2829">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped>

</style>
